import React, { useCallback, useMemo } from 'react';
import { useCurrentDecedentId } from '@/app/providers/DecedentProvider';
import FormConstructor from '@/common/containers/FormConstructor/index';
import { useSectionsQuestions } from '@/common/hooks/index';
import Loader from '@/common/components/Loader/index';
import { useQuestionListQuery } from '@/entities/question';

const MainTasks = ({ onSubmit, ...props }) => {
  const decedentId = useCurrentDecedentId();
  const questionListQuery = useQuestionListQuery('main', decedentId);
  const payload = useMemo(() => {
    if (!questionListQuery.data) {
      return {};
    }

    const { list, answers } = questionListQuery.data;
    return {
      questions: list.map((item) => {
        if (item.subsection === 'main_fin') {
          item.questions[0].children[0].answerOptions.listItemDeleteText =
            'Are you sure you want to delete this Financial Institution and all of it’s associated Financial Accounts? \n This action cannot be undone.';
        }
        return item;
      }),
      answers,
    };
  }, [questionListQuery.data]);
  const formKey = String(questionListQuery.dataUpdatedAt || '1');

  const { questions } = useSectionsQuestions(payload.questions);

  const handleSubmit = useCallback(
    async (form) => {
      await onSubmit(form);
      await questionListQuery.refetch();
    },
    [onSubmit, questionListQuery]
  );

  return questions.length ? (
    <FormConstructor
      {...props}
      onSubmit={handleSubmit}
      questions={questions}
      answers={payload.answers}
      key={formKey}
    />
  ) : (
    <Loader />
  );
};

export default MainTasks;
